import { render } from "./approvalMatrix.vue?vue&type=template&id=2d6ff202&scoped=true"
import script from "./approvalMatrix.vue?vue&type=script&lang=js"
export * from "./approvalMatrix.vue?vue&type=script&lang=js"

import "./approvalMatrix.vue?vue&type=style&index=0&id=2d6ff202&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6ff202"]])

export default __exports__